import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiEye } from '@mdi/js';
import { IBoletim } from '../../types';
import BoletinsService from '@/views/boletins/service';
import SdsSnackbarQueue from '@ungp/sds-snackbar-queue';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

interface IProps {
  boletim?: IBoletim;
  tipoBoletimParaImpressao?: 'COM_DOCUMENTO' | 'SEM_DOCUMENTO' | null;
  isSelecionado: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardResultado',
  props: {
    boletim: null,
    tipoBoletimParaImpressao: null,
    isSelecionado: { type: Boolean }
  },
  emits: ['toggle-check'],
  setup(__props: any) {

const props = __props as {
  boletim?: IBoletim;
  tipoBoletimParaImpressao?: 'COM_DOCUMENTO' | 'SEM_DOCUMENTO' | null;
  isSelecionado: boolean;
};





const expandido = ref(true);

const showDetalhes = ref(false);

const title = computed(() => props.boletim?.deTitulo || '');

const periodoPublicacao = computed(() => {
  const nuMes = props.boletim?.nuMes;
  const nuAno = props.boletim?.nuAno;
  return nuMes && nuAno ? `${nuMes}/${nuAno}` : '';
});

const highlightedDesc = computed(() => props.boletim?.highlightedDesc || '');

const desabilitarImpressao = computed(() => {
  const elementoTemDocumento = props.boletim?.cdDocumento;

  if (
    props.tipoBoletimParaImpressao === 'COM_DOCUMENTO' &&
    !elementoTemDocumento
  ) {
    return true;
  }

  if (
    props.tipoBoletimParaImpressao === 'SEM_DOCUMENTO' &&
    elementoTemDocumento
  ) {
    return true;
  }

  return false;
});

watch(
  () => props.boletim,
  async (newValue, oldValue) => {
    if (newValue != oldValue) {
      expandido.value = true;
      showDetalhes.value = false;
    }
  },
  { deep: true }
);

const download = () => {
  const boletimComDocumento =
    !!props.boletim?.cdDocumento && props.boletim?.flJurisprudencia !== 'S';
  const boletimSemDocumento =
    !props.boletim?.cdDocumento || props.boletim?.flJurisprudencia === 'S';

  if (boletimSemDocumento) {
    BoletinsService.downloadBoletimSemDocumento([props.boletim!.cdBoletim!]);
    return;
  }

  if (boletimComDocumento) {
    downloadBoletimComDocumento([props.boletim.cdDocumento!]);
  }
};

const downloadBoletimComDocumento = async (codigosDocumentos: number[]) => {
  try {
    const blob = await BoletinsService.downloadBoletimComDocumento(
      codigosDocumentos
    );

    if (!blob) {
      throw new Error();
    }

    const data = blob.slice(0, blob.size, 'application/pdf');
    const file = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = file;
    a.download = 'relatorio-boletim.pdf';
    document.body.appendChild(a);
    a.click();
  } catch (error) {
    SdsSnackbarQueue.error(
      String(error) || 'Não foi possível realizar o download'
    );
    return;
  }
};

return { __sfc: true,props, expandido, showDetalhes, title, periodoPublicacao, highlightedDesc, desabilitarImpressao, download, downloadBoletimComDocumento, CardExpand, mdiEye, mdiChevronDown, mdiChevronUp }
}

})